import { notLoginInstance } from './axiosInterceptor';

export const nlGet = async url => {
  const response = await notLoginInstance.get(url);
  return response.data.results;
};

export const nlPost = async (url, param) => {
  const isFormData = param instanceof FormData;

  const config = isFormData ? {} : {};

  const response = await notLoginInstance.post(url, param, config);

  return response.data.results;
};

export const nlPut = async (url, param) => {
  const response = await notLoginInstance.put(url, param);
  return response.data.results;
};

export const nlDelete = async (url, param) => {
  const response = await notLoginInstance.delete(url, {
    data: param,
  });
  return response.data.results;
};
